@if (aufteilungsSchluessels && aufteilungsSchluessels.length > 0) {
  <mat-list>
    <div class="ats-list-header" fxLayout="row" style="margin-bottom: 20px; padding-bottom: 10px;">
      <div fxFlex="40">Netzbetreiber</div>
      <div fxFlex="15" fxLayout="column">
        Aggregierte Endverbraucherlast [MW]
      </div>
      <div fxFlex="15" fxLayout="column">
        Aggregierte installierte konventionelle Erzeugerleistung [MW]
      </div>
      <div fxFlex="15" fxLayout="column">Aggregierte installierte EEG/KWKG Erzeugerleistung [MW]
      </div>
      <div fxFlex="15" fxLayout="column">
        EEG/KWKG Erzeugerleistung (Abregelbarer Anteil) [MW]
      </div>
    </div>
    @for (ats of aufteilungsSchluessels; track ats) {
      <div fxLayout="row">
        <mat-list-item class="with-gap" style="margin-bottom: 5px; padding-bottom: 10px;">
          <tnb-netzbetreiber-display-card [netzbetreiber]="ats.westnetzNetzbetreiberDatenabfrageRto"
          fxFlex="40"></tnb-netzbetreiber-display-card>
          <div fxFlex="15" style="font-size: x-large">{{ats.aggregierteEndverbraucherlast}}</div>
          <div fxFlex="15"
          style="font-size: x-large">{{ats.aggregierteInstallierteKonventionelleErzeugerleistung}}</div>
          <div fxFlex="15" style="font-size: x-large">{{ats.aggregierteInstallierteEEGErzeugerleistung}}</div>
          <div fxFlex="15" style="font-size: x-large">{{ats.eegKwkgErzeugerleistungAbregelbarerAnteil}}</div>
        </mat-list-item>
      </div>
    }
  </mat-list>
} @else {
  <p data-qa="aufteilungsschluesselList-NoATSYet">Kein Aufteilungsschlüssel für diese Datenabfrage gemeldet.</p>
}
